'use client'

import { useRef, useState } from 'react'
import { IconUser } from '@tabler/icons-react'
import { useSession } from 'next-auth/react'

import MenuItemsList from 'composition/profile/navigation/MenuItemsList'
import {
  CustomerTypes,
  extractCustomerFromClientSession
} from 'modules/customer'
import Button from 'shared/ui/Button'
import { Popover } from 'shared/ui/Popover'
import { addTestId } from 'shared/utils/tests'

import styles from './ProfileDropdown.module.scss'

interface ProfileDropdownProps {
  isMobile?: boolean
}

const ProfileDropdown = ({ isMobile }: ProfileDropdownProps) => {
  const anchorElRef = useRef<HTMLButtonElement | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const session = useSession()
  const user: CustomerTypes | undefined = extractCustomerFromClientSession(session)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleOpen = () => {
    setIsOpen(true)
  }

  return (
    <>
      <Button
        className={styles.profileButton}
        id='navbar_profile_icon'
        onClick={handleOpen}
        aria-label='Profil'
        role='button'
        aria-expanded={isOpen}
        aria-haspopup='true'
        aria-controls='profile-dropdown'
        variant={isMobile ? 'neutralText' : 'neutralOutline'}
        size='large'
        ref={anchorElRef}
        {...addTestId('profile-dropdown-trigger-button')}
      >
        <IconUser width={24} height={24} />
        <div className={styles.tabletContent}>Profil</div>
      </Button>
      <Popover
        id='profile-dropdown'
        anchorEl={anchorElRef}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <div
          className={styles.profileMenuDropdown}
          id='profile-dropdown-content'
        >
          <div className={styles.popupHeader}>
            <div className={styles.title}>Profil</div>
            <div className={styles.loggedInUser}>
              <div className={styles.loggedInUserLabel}>Zalogowany jako:</div>
              <div
                className={styles.loggedInUserEmail}
                {...addTestId('profile-dropdown-customer-email')}
              >
                {user?.email}
              </div>
            </div>
          </div>
          <MenuItemsList onClose={handleClose} />
        </div>
      </Popover>
    </>
  )
}

export default ProfileDropdown
